import React from 'react';
import Modal from 'react-modal';

import './ModalWindow.component.scss';

/* ----- Types ----- */

type Props = {
  children: JSX.Element,
  isOpen: boolean,
  onRequestClose: () => void,
  title: string
};

/* ----- Main Component ----- */
const ModalWindow = (props: Props) => {

  const modalStyles = {
    content: {
      margin: '0 auto',
      maxWidth: window.screen.width > 440 ? '600px' : '375px',
      border: 'none'
    },
    overlay: {
      border: 'none'
    }
  };

  const {children, isOpen, onRequestClose, title} = props;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => onRequestClose()}
      style={modalStyles}
      ariaHideApp={false}
    >
      <div className="modal-window">
        <div className="modal-window__header">
          <p className="modal-window__title">
            {title}
          </p>
          <button
            onClick={() => onRequestClose()}
            className="modal-window__hide-button"
            type="button"
          >
            &times;
          </button>
        </div>
        <div className="modal-window__content">
          {children}
        </div>
      </div>
    </Modal>

  );
};

export default ModalWindow;
